const COLORS = {
  purple: "#6366F1",
  teal: "#14B8A6",
  green: "#22C55E",
  greenDark: "#16A34A",
};

const KPI_META = {
  "QR Opens": { icon: "GridIcon", iconColor: COLORS.purple },
  "Bookings Made": { icon: "CheckSquareIcon", iconColor: COLORS.greenDark },
  Completed: { icon: "CheckCircleIcon", iconColor: COLORS.greenDark },
  "Active Venues": { icon: "MapPinIcon", iconColor: COLORS.purple },
  "Overall Success": { icon: "StarIcon", iconColor: "#fff" },
};

const FUNNEL_COLORS = [COLORS.purple, COLORS.teal, COLORS.green];

const CONVERSION_COLORS = {
  "Booking conversion": COLORS.purple,
  "Completion rate": COLORS.teal,
  "Overall success": COLORS.green,
};

export function getDefaultDateRange() {
  const to = new Date();
  to.setHours(0, 0, 0, 0);
  const from = new Date(to);
  from.setDate(from.getDate() - 7);
  return { from, to };
}

export function formatCurrency(value) {
  if (typeof value === "string" && value.trim() !== "") return value;
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export const emptyAnalytics = {
  kpis: [],
  funnel: [],
  overallSuccess: 0,
  revenue: formatCurrency(0),
  conversionRates: [],
  venues: [],
};

/** Enrich API payload with UI-only icon/color metadata. */
export function normalizeAnalytics(payload = {}) {
  const kpis = (payload.kpis || []).map((kpi) => {
    const meta = KPI_META[kpi.title] || {
      icon: "ActivityIcon",
      iconColor: COLORS.purple,
    };
    return {
      ...kpi,
      value: String(kpi.value != null ? kpi.value : "0"),
      icon: meta.icon,
      iconColor: meta.iconColor,
      highlight: !!kpi.highlight,
    };
  });

  const funnel = (payload.funnel || []).map((stage, index) => ({
    ...stage,
    percent: Number(stage.percent) || 0,
    value: Number(stage.value) || 0,
    color: FUNNEL_COLORS[index] || COLORS.purple,
  }));

  const conversionRates = (payload.conversionRates || []).map((rate, index) => ({
    ...rate,
    value: Number(rate.value) || 0,
    color:
      CONVERSION_COLORS[rate.label] || FUNNEL_COLORS[index] || COLORS.purple,
  }));

  const venues = (payload.venues || []).map((venue) => ({
    ...venue,
    qrOpens: Number(venue.qrOpens) || 0,
    bookingsMade: Number(venue.bookingsMade) || 0,
    completed: Number(venue.completed) || 0,
    conversion: Number(venue.conversion) || 0,
  }));

  const revenueRaw =
    payload.revenue != null
      ? payload.revenue
      : payload.revenueCollected != null
        ? payload.revenueCollected
        : payload.total_revenue != null
          ? payload.total_revenue
          : 0;

  return {
    kpis,
    funnel,
    overallSuccess: Number(payload.overallSuccess) || 0,
    revenue: formatCurrency(revenueRaw),
    conversionRates,
    venues,
  };
}

export { COLORS };
